import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { faFileInvoice, faFileZip, faFileExcel } from '@fortawesome/free-solid-svg-icons'
library.add(faFileInvoice)
library.add(faFileExcel)
import { library } from '@fortawesome/fontawesome-svg-core'
import TabContext from '@mui/lab/TabContext';
import TabLista from './AnexosComponent/ToolBarComponent/TabLista'
import TabPaneles from './AnexosComponent/ToolBarComponent/TabPaneles'
import DocumentacionGeneralComponent from './AnexosComponent/DocumentacionComponent/DocumentacionGeneralComponent'


function InformacionFC09_OCComponent(props) {

    const informacionDetalle = useSelector(store => store.SolicitudesFC09_OC.informacionDetalle)
    console.log("informaciio detalle ", informacionDetalle)
    const dataUser = useSelector(store => store.Usuario.user)

    const [value, setValue] = React.useState('documentacion');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Fragment>
            {dataUser[0]?.tipousuario?.idtipousuario == 11 &&
                <h3 className='text-center pt-3' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>SOLICITUD EN REVISIÓN OC <br /></h3>
            }
            <div className='container mt-5 pt-2'>
                {/*<TabContext value={value} >
                    <TabLista value={value} handleChange={handleChange} />
                    
                    <TabPaneles value="documentacion">*/}
                       <DocumentacionGeneralComponent />
                    {/*</TabPaneles>
                    
                    <TabPaneles value="productos">
                    </TabPaneles>

                </TabContext>*/}

            </div>

        </Fragment>
    )
}

export default withRouter(InformacionFC09_OCComponent)